import React, { useEffect } from 'react';
import { IStep, IStepData } from '../..';
import { appTheme } from '../../../../theme';
import {
  Container, Description, Item, Label,
  LabelContainer, List, Radio, RadioContainer,
  RadioInner, Title,
} from './styles';

export interface ISetTrainingSessionTimeScreenProps {
  step: IStep,
  trainingSessionTime: string | null,
  onClick: (value: string) => void,
  setButtonDisabled: (bool: boolean) => void,
}

function SetTrainingSessionTimeScreen({
  step, trainingSessionTime, onClick, setButtonDisabled,
}: ISetTrainingSessionTimeScreenProps) {
  useEffect(() => {
    if (trainingSessionTime) setButtonDisabled(false);
    else setButtonDisabled(true);
  }, [trainingSessionTime]);

  return (
    <Container>
      <Title>{step.title}</Title>

      <Description>{step.description}</Description>

      <List>
        {
          step.data.map((item: IStepData) => (
            <Item
              key={item.label}
              onClick={() => onClick(item.value as string)}
              style={{ borderColor: `${trainingSessionTime === item.value ? appTheme.gray : appTheme.cardB3}` }}
            >
              <RadioContainer>
                <Radio
                  style={{
                    backgroundColor: trainingSessionTime === item.value
                      ? appTheme.title : appTheme.cardB3,
                  }}
                >
                  <RadioInner
                    style={{
                      backgroundColor: trainingSessionTime === item.value
                        ? appTheme.title : appTheme.cardB3,
                    }}
                  />
                </Radio>
              </RadioContainer>

              <LabelContainer>
                <Label>{(item.label as string).toUpperCase()}</Label>
              </LabelContainer>
            </Item>
          ))
        }
      </List>
    </Container>
  );
}

export default SetTrainingSessionTimeScreen;
